import expandPlaceholders from './expand-placeholders';

export default function<T>(property: Scope.Property<T>, args?: { [key: string]: string | number }): T {
  let value = property ? (property as any).$c : null;
  if (typeof value === 'string' && args) {
    value = expandPlaceholders(value, args);
  }
  return value;
}
